import { LockIconFill } from "assets/icons";
import "./style.scss";

function UpgradeBox({ onClick }) {
  return (
    <div className="upgrade-box-container" onClick={onClick}>
      <span className="lock-icon">
        <LockIconFill />
      </span>
      <span className="font-body-normal fw-600">
        Upgrade to unlock summary view
      </span>
    </div>
  );
}

export default UpgradeBox;
